export const placeFilterItems = [
  {
    title: 'Весь номер',
    value: 'whole',
  },
  {
    title: 'Осн.',
    value: 'base',
  },
  {
    title: 'Доп.',
    value: 'ext',
  },
];

export const minOrderPeriod = 1;
export const maxOrderPeriod = 100;
